module.exports = __webpack_public_path__ + "img/Step2.8c331ad4.png";